import React from "react";
import telephone from './assets/telephone.jpg';

function Contact()
{
    return(
        <>
        <div className="pagecontainer"> 
           <div className="flexrow">
                <div className="itembox">
                <h1>Its a Contact Page</h1>
        <p>Get in touch with us here.</p>
                </div>

                 <div className="itembox">
                 <img src={telephone} alt="telephone"/>
                 </div>
           </div>

        </div>

        </>

    );

};

export default Contact;